import React from "react";
import "./advertisement.styles.scss";

const Advertisement = ({ ad }) => {
  const { name, location, imageFile } = ad;
  const imgSrc = require(`../../resources/images/${imageFile}`);

  const adStyle = {
    backgroundImage: "url(" + imgSrc + ")",
  };

  return (
    <div className="tour-advertisement" style={adStyle}>
      <div className="tour-advertisement-dark-overlay">
        <span className="hero-title">LiveTour</span>
        <div className="advertised-property-details">
          <span className="advertised-property-text">{name}</span>
          <span className="advertised-property-location">{location}</span>
          <button className="advertised-property-button">Learn more</button>
        </div>
      </div>
    </div>
  );
};

export default Advertisement;
